import React, { useState } from 'react';
import { useNavigate } from 'react-router';

import { Box, CssBaseline, AppBar, Drawer, Toolbar, Typography, Menu, MenuItem, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getStyles } from './styles';
import HeaderMenu from './HeaderMenu';
import { AccountCircle } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import authService from '../../services/AuthService';
interface HeaderProps {
  openHamburgerMenu?: boolean;
}

function Header({ openHamburgerMenu }: HeaderProps ) {
  const theme = useTheme();
  const styles = getStyles(theme);
  const navigate = useNavigate();

  const profile = authService.getUser();
  const [anchorEl, setAnchorEl] = useState(null);

  // Memoized version of the logout function
  // Needs memoizing as it's a dep for the loginEffect
  const logoutAction = () => {
    authService.logout();
    navigate('/signed-out');
  };

  const isMenuOpen = Boolean(anchorEl);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const accountMenuId = 'account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={accountMenuId}
      data-testid={accountMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={logoutAction}>Log Out</MenuItem>
    </Menu>
  );

  const [menuState, setMenuState] = useState(openHamburgerMenu? openHamburgerMenu : false);

  const toggleDrawer = (open: boolean) => (
    event: React.KeyboardEvent | React.MouseEvent,
  ) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setMenuState(open);
  };

  const accountLabel = 'BEABLE\'s account';
  return (
    <div>
      <CssBaseline />
      <AppBar
        position='fixed'
        sx={[styles.appBar, styles.colorPrimary]}
      >
        <Toolbar
          sx={styles.toolbar}
          data-testid='topnav-toolbar'
        >
          <div>
            <IconButton
              edge='start'
              data-testid='hamburger-icon'
              sx={styles.menuButton}
              color='inherit'
              aria-label='menu'
              onClick={toggleDrawer(true)}
              size="large">
              <MenuIcon />
            </IconButton>
            <Drawer open={menuState} onClose={toggleDrawer(false)}>
              <HeaderMenu
                onClick={() => toggleDrawer(false)}
                profile={profile}
              />
            </Drawer>
          </div>
          <Typography
            component='h1'
            variant='h6'
            noWrap
            sx={[{
              color: 'inherit'
            }, styles.title]}>
            Beable: Administration
          </Typography>
          <Box sx={styles.grow} />
          <span>{profile?.username}</span>
          <Box sx={styles.sectionDesktop}>
            <IconButton
              edge='end'
              aria-label={accountLabel}
              aria-controls={accountMenuId}
              data-testid='profile-icon'
              aria-haspopup='true'
              onClick={handleProfileMenuOpen}
              color='inherit'
              size="large">
              <AccountCircle />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMenu}
    </div>
  );
}
export default Header;